export default __webpack_public_path__ + "static/media/v-bt-l.621e5c33.png";